import { Card } from "src/components/UI/Card";
import TitleTooltip from "src/components/UI/TitleTooltip";
import { KeywordAssistPageDetail } from "../../types/keyword-assist.type";

interface Props {
    meta: KeywordAssistPageDetail;
}

const HelpCircleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-4 h-4 text-[#98A2B3] cursor-pointer hover:text-[#4F46E5] transition-colors">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
    </svg>
);

const WarningIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="#D97706" className="w-4 h-4 shrink-0">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
    </svg>
);

const HealthyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="#12B76A" className="w-4 h-4 shrink-0">
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
    </svg>
);

export default function KAPageTagsAudit({ meta }: Props) {
    return (
        <Card className="flex flex-col justify-between h-full">
            <div className="px-6">
                <div className="flex items-center gap-2 mb-4">
                    {/* <h3 className="text-lg font-bold text-[#1D2939]">Page Tags Audit</h3>
                    <CustomTooltip title={<Typography className="text-xs">Review title, description, and primary H1 structures for optimal search rendering.</Typography>} placement="top" arrow>
                        <span className="flex items-center">
                            <HelpCircleIcon />
                        </span>
                    </CustomTooltip> */}
                    <TitleTooltip>
                        <TitleTooltip.Text title="Page Tags Audit" className="!text-[#475467] !font-medium !text-base">
                            <TitleTooltip.Tooltip tooltip={
                            <p className="text-primary text-sm font-medium">
                                Review title, description, and primary H1 structures for optimal search rendering.
                            </p>
                            } />
                        </TitleTooltip.Text>
                    </TitleTooltip>
                </div>

                <div className="space-y-2">
                    {/* Title tag */}
                    <div className="bg-[#F8F9FC] border border-[#EAECF0] rounded-xl p-4 flex flex-col gap-2">
                        <div className="flex justify-between items-center text-sm font-semibold text-[#475467]">
                            <span>SEO Title Tag</span>
                            <span className="flex items-center gap-1 font-semibold text-xs">
                                {meta.page_tags_audit.seo_title_tag.char_count <= meta.page_tags_audit.seo_title_tag.max_chars ? <HealthyIcon /> : <WarningIcon />}
                                <span className={meta.page_tags_audit.seo_title_tag.char_count <= meta.page_tags_audit.seo_title_tag.max_chars ? 'text-[#12B76A]' : 'text-[#D97706]'}>
                                    {meta.page_tags_audit.seo_title_tag.char_count} / {meta.page_tags_audit.seo_title_tag.max_chars} Chars
                                </span>
                            </span>
                        </div>
                        <p className="text-xs font-semibold text-[#1D2939]">
                            {meta.page_tags_audit.seo_title_tag.value}
                        </p>
                    </div>

                    {/* Meta Description */}
                    <div className="bg-[#F8F9FC] border border-[#EAECF0] rounded-xl p-4 flex flex-col gap-2">
                        <div className="flex justify-between items-center text-sm font-semibold text-[#475467]">
                            <span>Meta Description</span>
                            <span className="flex items-center gap-1 font-semibold text-xs">
                                {meta.page_tags_audit.meta_description.char_count <= meta.page_tags_audit.meta_description.max_chars ? <HealthyIcon /> : <WarningIcon />}
                                <span className={meta.page_tags_audit.meta_description.char_count <= meta.page_tags_audit.meta_description.max_chars ? 'text-[#12B76A]' : 'text-[#D97706]'}>
                                    {meta.page_tags_audit.meta_description.char_count} / {meta.page_tags_audit.meta_description.max_chars} Chars
                                </span>
                            </span>
                        </div>
                        <p className="text-xs text-[#475467] leading-relaxed font-medium">
                            {meta.page_tags_audit.meta_description.value}
                        </p>
                    </div>

                    {/* Primary Heading H1 */}
                    <div className="bg-[#F8F9FC] border border-[#EAECF0] rounded-xl p-4 flex flex-col gap-2">
                        <div className="flex justify-between items-center text-sm font-semibold text-[#475467]">
                            <span>Primary H1 Heading</span>
                            <span className="text-xs text-[#344054] bg-[#F2F4F7] px-2 py-0.5 rounded font-semibold uppercase tracking-wide">
                                H1 Tag
                            </span>
                        </div>
                        <p className="text-xs font-semibold text-[#1D2939] leading-relaxed">
                            {meta.page_tags_audit.h1.value}
                        </p>
                    </div>
                </div>
            </div>
        </Card>
    );
}
